export default __webpack_public_path__ + "/dist/images/695524.2679c2a713205915b0dd7d8afb64a3a3.png";